import { createContext } from 'react';

interface NotificationMethods {
    addNotification?(content): void;
    removeNotification?(content): void;
}

export const NotificationContext = createContext<NotificationMethods>({});
